import type { FileKind } from '../types';

const IMAGE_EXTS = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'avif', 'heic', 'heif', 'bmp', 'ico']);
const VIDEO_EXTS = new Set(['mp4', 'webm', 'mov', 'mkv', 'avi', 'm4v']);
const AUDIO_EXTS = new Set(['mp3', 'wav', 'ogg', 'flac', 'm4a', 'aac']);
const DOCUMENT_EXTS = new Set(['pdf', 'doc', 'docx', 'odt', 'rtf']);
const ARCHIVE_EXTS = new Set(['zip', '7z', 'tar', 'gz', 'bz2', 'rar']);
const TEXT_EXTS = new Set([
  'txt', 'md', 'json', 'csv', 'tsv', 'log', 'html', 'xml', 'yml', 'yaml', 'toml',
]);

function extOf(name: string): string {
  const idx = name.lastIndexOf('.');
  if (idx <= 0 || idx === name.length - 1) return '';
  return name.slice(idx + 1).toLowerCase();
}

export function classifyFile(filename: string, mime: string): FileKind {
  const ext = extOf(filename);
  if (ext) {
    if (IMAGE_EXTS.has(ext)) return 'image';
    if (VIDEO_EXTS.has(ext)) return 'video';
    if (AUDIO_EXTS.has(ext)) return 'audio';
    if (DOCUMENT_EXTS.has(ext)) return 'document';
    if (ARCHIVE_EXTS.has(ext)) return 'archive';
    if (TEXT_EXTS.has(ext)) return 'text';
  }
  const m = (mime || '').toLowerCase();
  if (m.startsWith('image/')) return 'image';
  if (m.startsWith('video/')) return 'video';
  if (m.startsWith('audio/')) return 'audio';
  if (m.startsWith('text/') || m === 'application/json') return 'text';
  if (m === 'application/pdf') return 'document';
  if (m === 'application/zip' || m === 'application/x-7z-compressed' || m === 'application/gzip' || m === 'application/x-tar') {
    return 'archive';
  }
  return 'other';
}

export function isImage(kind: FileKind): boolean {
  return kind === 'image';
}

export function markdownEmbed(filename: string, url: string, kind: FileKind): string {
  if (kind === 'image') return `![${filename}](${url})`;
  return `[${filename}](${url})`;
}
